// Hoja de estilos de toda la app (Bootstrap + tema de Bitácann).
// La cargan los dos layouts: el de Inertia y el de las vistas de Devise.
import '../styles/application.scss'

// Service worker: solo sirve la pantalla "sin conexión" cuando no hay red.
// Hace falta para que la app se pueda instalar en el celular.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      console.warn('No se pudo registrar el service worker', error)
    })
  })
}
